import React from 'react';

export interface GridLinesProps {
	/** Whether to show the grid lines */
	showGrid?: boolean;
	/** Color of the grid lines */
	gridColor?: string;
	/** Diameter of the grid area */
	diameter: number;
	/** Width of the grid pattern (default: 12) */
	patternWidth?: number;
	/** Height of the grid pattern (default: 12) */
	patternHeight?: number;
	/** Stroke width of the grid lines (default: 0.25) */
	strokeWidth?: number;
	/** Pattern ID for the grid (default: "grid-pattern") */
	patternId?: string;
	/** Additional CSS classes */
	className?: string;
	/** Additional inline styles */
	style?: React.CSSProperties;
}

/**
 * GridLines Component
 *
 * Renders a grid pattern using SVG patterns and fills.
 * The grid is centered at (0,0) and extends to the specified diameter.
 *
 * @param showGrid - Whether to show the grid lines
 * @param gridColor - Color of the grid lines
 * @param diameter - Diameter of the grid area
 * @param patternWidth - Width of the grid pattern
 * @param patternHeight - Height of the grid pattern
 * @param strokeWidth - Stroke width of the grid lines
 * @param patternId - Pattern ID for the grid
 * @param className - Additional CSS classes
 * @param style - Additional inline styles
 */
export const GridLines: React.FC<GridLinesProps> = ({
	showGrid = true,
	gridColor = '#777',
	diameter,
	patternWidth = 12,
	patternHeight = 12,
	strokeWidth = 0.25,
	patternId = 'grid-pattern',
	className = '',
	style = {}
}) => {
	console.log('GridLines: diameter', diameter);
	if (!showGrid || !diameter) {
		return null;
	}

	return (
		<>
			{/* Define the grid pattern */}
			<defs>
				<pattern
					id={patternId}
					width={patternWidth}
					height={patternHeight}
					patternUnits="userSpaceOnUse"
				>
					<path
						d={`M ${patternWidth} 0 L 0 0 0 ${patternHeight}`}
						fill="none"
						stroke={gridColor}
						strokeWidth={strokeWidth}
					/>
				</pattern>
			</defs>

			{/* Grid background circle - positioned at center */}
			<circle
				cx="0"
				cy="0"
				r={diameter / 2}
				fill={`url(#${patternId})`}
				className={className}
				style={style}
			/>
		</>
	);
};
